import error from './errors';
import validate from './validates';
import menu from './menu';
import vuetify from './vuetify';

export default {
  error,
  validate,
  menu,
  $vuetify: vuetify,
  app: {
    title: 'Base frotend',
    account: 'Mi cuenta',
    settings: 'Configuración',
    logOut: 'Cerrar Sesión'
  },
  login: {
    title: 'Ingrese como Usuario',
    title_nit: 'Ingrese como Administrador',
    user: 'Nombre de usuario',
    password: 'Contraseña',
    nit: 'NIT',
    rememberMe: 'Recuerdame',
    forgotPass: '¿Se te olvidó tu contraseña?',
    login: 'Ingresar',
    noAccount: '¿No tienes una cuenta?',
    signUp: 'Registrate aquí'
  },
  common: {
    add: 'Agregar',
    required: 'Campo obligatorio',
    cancel: 'Cancelar',
    save: 'Guardar',
    rowsPage: 'Filas por página',
    updateList: 'Actualizar esta lista',
    filters: 'Filtros/búsqueda',
    of: 'de',
    active: 'Activo',
    observation: 'Observar',
    firm: 'Firmar',
    approve: 'Aprobar y Firmar',
    edit: 'Editar',
    status: 'Estado',
    actions: 'Acciones',
    close: 'Cerrar'
  },
  entity: {
    title: 'Entidades',
    add: 'Agregar nueva entidad',
    crud: {
      edit: 'Editar',
      code: 'Código',
      name: 'Nombre',
      acronym: 'Sigla',
      description: 'Descripción',
      status: 'Estado',
      addEnt: 'Agregar entidad',
      editEnt: 'Editar entidad',
      address: 'Dirección',
      email: 'Correo electrónico de atención al cliente',
      phones: 'Teléfono(s)',
      web: 'Página web de la entidad'
    }
  },
  account: {
    title: 'Cuentas',
    add: 'Agregar nueva cuenta',
    select: 'Seleccione una entidad para ver sus cuentas',
    crud: {
      edit: 'Editar',
      accountNumber: 'Nro. de cuenta',
      status: 'Estado',
      entity: 'Entidad',
      addAc: 'Agregar cuenta',
      editAc: 'Editar cuenta'
    }
  },
  user: {
    title: 'Usuarios',
    add: 'Agregar nuevo usuario',
    crud: {
      edit: 'Editar',
      user: 'Usuario',
      userData: 'Datos del usuario',
      entity: 'Entidad',
      role: 'Rol',
      status: 'Estado',
      addUser: 'Agregar usuario',
      editUser: 'Editar usuario',
      fullname: 'Nombre completo',
      email: 'Correo electrónico'
    }
  },
  rol: {
    title: 'Roles',
    add: 'Agregar nuevo rol',
    crud: {
      name: 'Nombre',
      description: 'Descripción',
      tipo: 'Tipo',
      path: 'Ruta',
      editRol: 'Editar Rol',
      addRol: 'Agregar Rol'
    }
  },
  parametro: {
    title: 'Parámetros',
    add: 'Agregar nuevo parámetro',
    preferencias: 'Preferencias',
    crud: {
      name: 'Nombre',
      value: 'Valor',
      label: 'Label',
      description: 'Descripción',
      editParametro: 'Editar Parámetro',
      addParametro: 'Agregar Parámetro'
    }
  },
  module: {
    title: 'Módulos y permisos',
    add: 'Agregar nuevo módulo',
    crud: {
      edit: 'Editar',
      module: 'Módulo padre',
      label: 'Título',
      path: 'Path',
      icon: 'Ícono',
      order: 'Orden',
      status: 'Estado',
      visible: 'Visible',
      is_visible: 'Es visible',
      submodule: 'Sub módulo',
      section: 'Sección',
      addModule: 'Agregar módulo',
      editModule: 'Editar módulo',
      permissions: 'Permisos'
    }
  },
  log: {
    title: 'Logs del sistema',
    crud: {
      nivel: 'Nivel',
      tipo: 'Tipo',
      mensaje: 'Mensaje',
      referencia: 'Referencia',
      ip: 'IP',
      fecha: 'Fecha de creación',
      usuario: 'Usuario'
    }
  },
  servicioIop: {
    title: 'Interoperabilidad',
    add: 'Agregar nuevo servicio',
    crud: {
      codigo: 'Código',
      metodo: 'Método',
      descripcion: 'Descripción',
      entidad: 'Entidad',
      url: 'Url',
      token: 'Token',
      tipo: 'Tipo',
      estado: 'Estado',
      editServicio: 'Editar Servicio Iop',
      addServicio: 'Agregar Servicio Iop'
    }
  },
  comun: {
    titulo: 'Declaración Jurada de Bienes y Rentas Digital',
    guardar: 'Guardar',
    cancelar: 'Cancelar',
    actualizar: 'Actualizar',
    doc_identidad: 'Número de Documento',
    email: 'Correo Electrónico',
    celular: 'Celular',
    sin_informacion: 'NO EXISTE NINGUNA INFORMACIÓN REGISTRADA',
    firma_pendiente: 'FIRMA PENDIENTE',
    sin_datos: 'Datos no disponibles',
    sin_resultados_busqueda: 'No se encontraron resultados de la búsqueda',
    nombre_completo: 'Nombre Completo'
  },
  dashboard: {
    primera_djbrd: 'Crear Primera Declaración',
    nueva_djbrd: 'Nueva Declaración',
    continuar_djbrd: 'Continuar con la Declaración',
    habilitar_djbrd: 'Habilitar Declaración',
    formulario: 'Descargar Formulario',
    certificado: 'Descargar Certificado',
    nueva_djbrd_titulo: 'Iniciar Declaración',
    datos_djbrd: 'Datos de la Declaración',
    mensaje_habilitar_djbrd: '¿Desea habilitar la declaración jurada para continuar con la declaración?',
    upd_info: 'Actualizar Información',
    genero: 'Género',
    upd_datos_personales: 'Actualizar Datos Personales',
    mensaje_datos_err: 'Los datos registrados no concuerdan con los datos de SEGIP y debe actualizarlos, existen las siguientes diferencias:'
  },
  datos_generales: {
    fecha_rectificacion: 'Fecha de Rectificación',
    formato_fecha: 'Formato DD/MM/AAAA',
    observacion: 'Observaciones de la Rectificación',
    observacion_hint: 'Las observaciones que tenga de la rectificación, máximo 100 caracteres.',
    observacion_span: 'Si desea modificar el motivo de la declaración, justifique la rectificación y el nuevo motivo.',
    declarar_como: 'Declarar Como:',
    boliviano: 'Servidor Público en Bolivia',
    extranjero: 'Servidor Público en el Exterior',
    lugar_residencia: 'El Lugar Donde Reside el Declarante ¿Es Capital de Departamento?',
    pais_residencia: 'País de Residencia del Declarante',
    localidad_residencia: 'Localidad de Residencia del Declarante'
  },
  decretos: {
    dec_1233_5: 'D.S. Nº1233 Art. 5 (DECLARACIÓN DURANTE EL EJERCICIO DEL CARGO). I. Todas las servidoras y servidores públicos deberán actualizar la información de su Declaración Jurada de Bienes y Rentas durante el ejercicio del cargo, presentando la misma durante el mes de su nacimiento si reside en las capitales de departamento, y si reside fuera de las capitales de departamento, contarán adicionalmente con el mes siguiente de su nacimiento.',
    dec_1233_3: 'D.S. Nº1233 Art. 3 Inc. a) Declaración Jurada de Bienes y Rentas: Es la obligación de toda servidora y servidor público de prestar declaración sobre los bienes, deudas y rentas que tiene antes, durante y después del ejercicio del cargo.',
    dec_sup_1233: 'D.S. Nº1233 Art. 5 (DECLARACIÓN DURANTE EL EJERCICIO DEL CARGO). I. Todas las servidoras y servidores públicos deberán actualizar la información de su Declaración Jurada de Bienes y Rentas durante el ejercicio del cargo, presentando la misma durante el mes de su nacimiento si reside en las capitales de departamento, y si reside fuera de las capitales de departamento, contarán adicionalmente con el mes siguiente de su nacimiento.',
    dec_sup_1233_3: 'D.S. Nº1233 Art. 3 Inc. a) Declaración Jurada de Bienes y Rentas: Es la obligación de toda servidora y servidor público de prestar declaración sobre los bienes, deudas y rentas que tiene antes, durante y después del ejercicio del cargo.'
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/es/messages.js